import React from 'react';

import PropTypes from 'prop-types';

import { CenterContainer, Container, HeaderText, MainText, RowButtonContainer, SecondarySmallText, SecondaryText } from './styles';
import { AnimatedIconFail } from '../../AnimatedIcon/AnimatedIconFail';
import { AnimatedIconSuccess } from '../../AnimatedIcon/AnimatedIconSuccess';
import { Button } from '../../Button/Button';
import { DiskButton } from '../../DiskButton/DiskButton';
import { Icon } from '../../Icon/Icon';
import { FixedBottomPanel } from '../FixedBottomPanel/FixedBottomPanel';
import { NavBar } from '../NavBar/NavBar';

export const InfoPage = (props) => {
    const setNavBarAlign = () => {
        if (props.backUrl) {
            return 'left';
        } else {
            return 'right';
        }
    };

    return (
        <Container data-testid={props.dataTestId} insideModalComponent={props.insideModalComponent}>
            {(props.backUrl || props.topButtonCaption) && (
                <NavBar align={setNavBarAlign()} insideStories={props.insideStories}>
                    {props.backUrl && (
                        <DiskButton
                            type={props.isTagA ? 'tagA' : null}
                            to={props.backUrl}
                            href={props.backUrl}
                            iconName={props.leftCloseIcon ? 'cross' : 'arrow-back'}
                            onClick={props.diskButtonOnClick}
                        />
                    )}
                    {props.topButtonCaption && (
                        <Button
                            type={props.topButtonType}
                            variant="tertiary"
                            size="tight"
                            caption={props.topButtonCaption}
                            onClick={props.topButtonOnClick}
                            href={props.topButtonLink}
                            dataTestId={props.topButtonDataTestId}
                        />
                    )}
                </NavBar>
            )}
            <CenterContainer>
                <div>
                    {props.iconName && <Icon name={props.iconName} color={props.iconColor} size="80px" />}
                    {!props.iconName && props.iconSrc && <img src={props.iconSrc} alt="" />}
                    {!props.iconName && !props.iconSrc && props.animatedIconSuccess && <AnimatedIconSuccess />}
                    {!props.iconName && !props.iconSrc && props.animatedIconFail && <AnimatedIconFail />}
                </div>
                {/* Для фиолетового выделения следующая конструкция: <><span>{purpleText}</span>{headerText}</span></>*/}
                {props.headerText && <HeaderText>{props.headerText}</HeaderText>}
                {props.secondaryText && <SecondaryText>{props.secondaryText}</SecondaryText>}
                {props.secondarySmallText && <SecondarySmallText>{props.secondarySmallText}</SecondarySmallText>}
                {/* текст небольшого размера */}
                {props.mainText && (
                    <MainText hasBorder={props.hasBorder} breakWord={props.breakWord}>
                        {props.mainText}
                    </MainText>
                )}
                {props.buttonRowCaption && (
                    <RowButtonContainer>
                        <Button
                            type={props.buttonRowType}
                            variant="row"
                            size="tight"
                            negativeMargin
                            caption={props.buttonRowCaption}
                            onClick={props.buttonRowOnClick}
                            target={props.buttonRowTarget}
                            href={props.buttonRowHref}
                            rel={props.buttonRowRel}
                        />
                    </RowButtonContainer>
                )}
            </CenterContainer>
            {props.primaryButtonCaption && (
                <FixedBottomPanel isRightAligned>
                    <Button
                        dataTestId={props.primaryButtonDataTestId}
                        type={props.primaryButtonType}
                        raised="true"
                        caption={props.primaryButtonCaption}
                        onClick={props.primaryButtonOnClick}
                        href={props.primaryButtonLink}
                        to={props.primaryButtonLink}
                    />
                </FixedBottomPanel>
            )}
        </Container>
    );
};

InfoPage.propTypes = {
    topButtonCaption: PropTypes.string,
    topButtonType: PropTypes.string,
    topButtonOnClick: PropTypes.func,
    topButtonLink: PropTypes.string,
    topButtonDataTestId: PropTypes.string,
    iconName: PropTypes.string,
    iconSrc: PropTypes.string,
    iconColor: PropTypes.string,
    headerText: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
    secondaryText: PropTypes.oneOfType([PropTypes.string, PropTypes.element, PropTypes.array]),
    secondarySmallText: PropTypes.oneOfType([PropTypes.string, PropTypes.element, PropTypes.array]),
    mainText: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
    hasBorder: PropTypes.bool,
    buttonRowType: PropTypes.string,
    buttonRowTarget: PropTypes.string,
    buttonRowRel: PropTypes.string,
    buttonRowCaption: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
    buttonRowOnClick: PropTypes.func,
    primaryButtonCaption: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
    primaryButtonType: PropTypes.string,
    primaryButtonOnClick: PropTypes.func,
    primaryButtonLink: PropTypes.string,
    buttonRowHref: PropTypes.string,
    insideModalComponent: PropTypes.bool, // если InfoPage находится в модалке
    isTagA: PropTypes.bool,
    breakWord: PropTypes.bool,
    animatedIconSuccess: PropTypes.bool,
    animatedIconFail: PropTypes.bool,
};
